/**
 * Port of reports.page. The Angular version was an empty shell with a TODO,
 * and the nav entry for it is still commented out in AppLayout. Kept so the
 * route resolves rather than redirecting to home.
 */
export default function ReportsPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-10">
      <h1 className="text-2xl font-semibold text-slate-900">Reports</h1>
      <p className="mt-2 text-gray1">Reports are not available yet.</p>
    </div>
  );
}
